import { Box } from "@mui/material";
import { IoMdClose } from "react-icons/io";

export default function TermsOfUse({ close }) {
  return (
    <Box
      style={{
        height: "100svh",
        width: "100svw",
        position: "fixed",
        backgroundColor: "white",
        display: "grid",
        gridTemplateRows: "auto auto",
      }}
    >
      {/* header */}
      <Box
        style={{
          backgroundColor: "#F07821",
          height: "3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0rem 1rem",
        }}
      >
        <h4
          style={{
            fontSize: "1.0625rem",
            color: "white",
            fontWeight: "600",
          }}
        >
          User Agreement - Terms of Use
        </h4>
        <IoMdClose
          style={{
            // fontWeight: "400",
            color: "white",
            // padding: "1px",
          }}
          onClick={() => close(false)}
        />
      </Box>

      {/* other modals */}

      <Box
        style={{
          padding: "1.5rem",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            margin: 0,
            fontFamily: "Arial, sans-serif",
            lineHeight: 1.6,
          }}
        >
          {/* Body with padding */}
          <div>
            <h2>VISALANCER TERMS OF USE</h2>
            <p>
              <strong>Effective Date:</strong> 19 Sep 2025
            </p>
            <p>
              <strong>Last Updated:</strong> 19 Sep 2025
            </p>
            <br />

            <p>
              The following Terms of Use (“Terms”) govern the access to and use
              of the VisaLancer platform (“Platform”) operated and owned by
              Visaero (Visaero Travel and Tourism LLC / Visaero Pte Ltd /
              Visaero India Pvt. Ltd) (“Visaero”, / the Company /“we”, “our”, or
              “us”) (collectively referred as Visaero’s Group Companies). The
              Platform includes Visaero’s official website, sub-domains,
              affiliated domains, mobile applications, and any other digital
              interfaces or services made available by Visaero from time to time
              (collectively referred to as “Visaero Platform”).
            </p>

            <p>
              For the purpose of these Terms, references to “you”, “your” or the
              “VisaLancer” shall mean any natural or legal person who registers
              on the Platform to participate in Visaero’s referral/affiliate
              program (“VisaLancer Program”), and who accepts these Terms as a
              binding contract. References to “user” in this document is limited
              to VisaLancers, and do not extend to customers or end-users
              referred through VisaLancers’ links.
            </p>

            <p>
              By accessing, browsing, registering on, or otherwise using the
              Platform, you acknowledge and agree to be bound by these Terms. If
              you do not agree, you must not register, access, or use the
              Platform in any manner.
            </p>

            <p>
              Visaero reserves the right to amend, modify, or replace these
              Terms at any time, by posting the revised version on the Platform.
              All such updates and amendments shall be effective immediately
              upon posting, and your continued use of the Platform thereafter
              shall constitute your deemed acceptance of the revised Terms.
            </p>

            <p>
              Please read these Terms carefully. These Terms, as amended from
              time to time, constitute a binding contract between you and
              Visaero. By clicking the “Accept” or “I Agree” button at the time
              of registration/login, or by continuing to access or use the
              Platform, you expressly agree and consent to be bound by these
              Terms of Use.
            </p>

            <h2>ABOUT US</h2>
            <p>
              Visaero operates a referral program that enables registered users
              (“Visa Lancers”) to promote Visaero’s services by sharing unique
              referral links, and to earn commission on successful leads and
              conversions (“Services”).
            </p>
            <p>
              Upon registration and acceptance into the program, VisaLancers are
              granted access to a personalized dashboard. The commission
              structure, eligibility, and applicable terms for payment are
              detailed within the VisaLancer dashboard and/or separate policies
              issued by Visaero from time to time. Visaero shall not be liable
              for any claims, losses, or refunds of commission except as
              expressly set out in these Terms.
            </p>

            <h2>ELIGIBILITY &amp; REGISTRATION</h2>
            <ul>
              <li>
                You must be at least 18 years of age and legally competent under
                applicable laws in your jurisdiction.
              </li>
              <li>
                You must provide accurate, complete, and up-to-date information
                during registration and ensure that such information remains
                current at all times.
              </li>
              <li>
                You are solely responsible for maintaining the confidentiality
                of your login credentials, including your username and password.
              </li>
              <li>
                Visaero reserves sole discretion to accept, reject, suspend, or
                terminate any VisaLancer account, with or without notice or
                reason.
              </li>
            </ul>

            <h2>SCOPE OF PARTICIPATION</h2>
            <p>
              Upon successful registration, you will be assigned a unique
              referral link to promote Visaero’s services. Your role as a Visa
              Lancer is strictly limited to referral activities. Nothing in
              these Terms shall be construed as creating, nor shall it create,
              any partnership, employment, agency, franchise, fiduciary, or
              joint venture relationship between you and Visaero.
            </p>

            <h2>VISALANCER OBLIGATIONS</h2>
            <ul>
              <li>
                Promote Visaero’s services truthfully, lawfully, and ethically.
              </li>
              <li>Refrain from misleading advertising or spam.</li>
              <li>
                Use only official referral links and promotional materials.
              </li>
              <li>Maintain confidentiality of account information.</li>
              <li>Comply with all applicable laws and regulations.</li>
            </ul>

            <h2>GRANT AND SCOPE OF LICENCE</h2>
            <p>
              Subject to compliance, Visaero grants you a limited, revocable,
              non-exclusive, non-transferable, and non-sublicensable licence to
              use the Platform and referral dashboard solely for lawful
              participation in the VisaLancer Program.
            </p>

            <h2>COMMISSION &amp; PAYMENT</h2>
            <p>
              You shall be entitled to receive a commission of 25% of the net
              service fee for each successful transaction completed through your
              referral link. Commissions are subject to Visaero’s payment
              policies, applicable laws, and deductions.
            </p>

            <h2>LICENCE RESTRICTIONS</h2>
            <p>
              You shall not copy, reproduce, disassemble, reverse engineer, or
              otherwise exploit the Platform or Materials except as expressly
              permitted under these Terms or applicable law.
            </p>

            <h2>ACCEPTABLE USE RESTRICTIONS</h2>
            <p>
              As a condition of participation, you shall not use the Platform in
              an unlawful, fraudulent, or abusive manner, or engage in spamming,
              unauthorized solicitation, or misrepresentation of Visaero.
            </p>

            <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
            <p>
              All intellectual property rights in the VisaLancer Platform,
              Materials, and Visaero services are owned by or licensed to
              Visaero. No rights or licenses are granted except as expressly
              permitted herein.
            </p>

            <h2>CONFIDENTIALITY &amp; DATA CONSENT</h2>
            <p>
              You agree to keep confidential all proprietary information and
              consent to Visaero’s collection and use of personal data in
              accordance with applicable laws and Visaero’s Privacy Policy.
            </p>

            <h2>NO WARRANTY OR SUPPORT</h2>
            <p>
              The Platform and Services are provided “as-is” and “as-available.”
              Visaero disclaims all warranties, express or implied, including
              merchantability and fitness for purpose.
            </p>

            <h2>LIMITATION OF LIABILITY</h2>
            <p>
              Visaero shall not be liable for indirect, incidental, or
              consequential damages. Aggregate liability shall not exceed the
              commissions actually paid to you in the three months preceding a
              claim.
            </p>

            <h2>TERMINATION</h2>
            <p>
              Visaero reserves the right to suspend or terminate your access for
              breach of these Terms, fraudulent conduct, or unlawful activity.
              Upon termination, you must cease all use of Visaero intellectual
              property.
            </p>

            <h2>COMMUNICATION BETWEEN VISAERO AND VISALANCER</h2>
            <p>
              You may contact Visaero at the official email address or methods
              provided on the Platform. Visaero may send notifications or
              updates via email, SMS, or in-app messages.
            </p>

            <h2>COMPLAINTS &amp; GRIEVANCES</h2>
            <p>
              If you have any queries or complaints, you may contact Visaero at{" "}
              <a href="mailto:dpo@visaero.co">dpo@visaero.co</a>.
            </p>

            <h2>EVENTS BEYOND VISAERO’S CONTROL</h2>
            <p>
              Visaero shall not be liable for failure or delay caused by events
              beyond its control, such as natural disasters, strikes, war,
              terrorism, or technical failures.
            </p>

            <h2>INDEMNIFICATION</h2>
            <p>
              You agree to indemnify and hold harmless Visaero and its
              affiliates from all claims, damages, and expenses arising out of
              your breach of these Terms or misuse of the Platform.
            </p>

            <h2>MODIFICATION OF TERMS</h2>
            <p>
              Visaero may modify these Terms at its discretion. Continued use of
              the Platform constitutes acceptance of updated Terms.
            </p>

            <h2>GOVERNING LAW AND DISPUTE RESOLUTION</h2>
            <p>
              These Terms shall be governed by the laws of the jurisdiction of
              the relevant Visaero Group Company. Disputes shall be resolved
              through arbitration or courts of competent jurisdiction.
            </p>

            <h2>MISCELLANEOUS</h2>
            <ul>
              <li>
                <strong>Entire Agreement:</strong> These Terms and the Privacy
                Policy constitute the entire agreement.
              </li>
              <li>
                <strong>Severability:</strong> If any provision is invalid, the
                remainder shall remain enforceable.
              </li>
              <li>
                <strong>No Waiver:</strong> Failure to enforce a right does not
                waive it.
              </li>
              <li>
                <strong>Assignment:</strong> You may not assign rights without
                consent. Visaero may assign freely.
              </li>
            </ul>

            <h2>DATA &amp; PRIVACY</h2>
            <p>
              By registering, you consent to Visaero collecting, processing, and
              storing your personal data as per applicable law and Privacy
              Policy.
            </p>

            <h2>OTHER IMPORTANT TERMS</h2>
            <p>
              By accessing or using the Platform, you acknowledge that you have
              read and agreed to abide by these Terms and the Privacy Policy.
              Continued use constitutes acceptance of modifications.
            </p>
          </div>
        </div>
      </Box>
    </Box>
  );
}
